<template>
  <div class="section section-tabs section-items">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xl-8 ">
          <div class="col-md-12 col-xl-12">
          <p class="item-title">About AI Integration</p>
            <div class="card11" >
              <div class="item-image-about">
              <img src="aiImg/index/aboutUs.jpg" alt="" style="height:220px;"/>
                &nbsp;
              </div>
              <div class="item-text-container" >
                AI Integration helps customers maximize productivity and reach their full potential with over 20 years
                of experience in the commercial and government technology sector. Machine learning increases business
                productivity and increases the effectiveness of employees. Organizations can make decisions more quickly,
                react to changing markets immediately, work more efficiently, and automate tasks when the workforce
                supply cannot keep up with the demand.
                <br>
                <br>
                <a class="" style="float:right; height:27px;" href="#/aboutus">
                     <p>More About Us</p>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-6 " style="display: inline-block;">
            <p class="item-title">Join Us at AI Integration</p>
            <div class="card11">
              <div class="item-image-joinus-tall">
              <img src="aiImg/index/joinus.jpg" alt="" style="height:100%;"/>
               &nbsp;
              </div>
              <div class="item-text-container-tall">
                AI Integration are continuously striving to be a better company that is open, friendly and honest
                with our employees. We created AI Integration to help people overcome their obstacles and succeed,
                that goes for our employees as well as our customers. If you are interested in being an integral
                part of a better company, please call or email and we can talk.
                <br>
                <br>
                <a class="" style="float:right; height:27px;" href="#/careers">
                     <p>Join Us</p>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-6 " style="display: inline-block;">
              <p class="item-title">Get In Touch With Us</p>
              <div class="card11">
                <div class="item-image-intouch-tall">
                <img src="aiImg/index/intouch.jpg" alt="" style="height:100%;"/>
                 &nbsp;
                </div>
                <div class="item-text-container-tall">
                  We would love to hear from you
                  If you would like to get more information about what we can do to help you. Please contact us using one of the following methods.
                  <br>
                  <br>
                  info@ai-integration.com
                  <br>
                  443-832-3719
                  <br>
                  <br>
                  <a class="" style="float:right; height:27px;" href="#/contact">
                       <p>Contact Us</p>
                  </a>

                </div>
              </div>
          </div>
          <div class="col-md-12 col-xl-12 ">
                    <p class="item-title">AI Integration and the Government</p>
                      <div class="card11">
                        <div class="item-image-gov">
                        <img src="aiImg/index/govWork.jpg" alt="" style="height:100%; "/>
                          &nbsp;
                        </div>
                        <div class="item-text-container">
                          AI Integration Inc. is a technologies company that specializes in bringing artificial intelligence and
                          machine learning into reach of commercial, government, and nonprofit organizations. Our team has decades
                          of experience within the information technology sector in the Intelligence Community and commercially.
                          We continue research and development on the newest technologies including new applications of artificial intelligence.
                          <br>
                          <br>
                          <a class="" style="float:right; height:27px;" href="#/contact">
                              <p>Contact Us</p>
                          </a>

                        </div>
                      </div>
                    </div>
        </div>


        <div class="col-md-12 ml-auto col-xl-4 mr-auto">
            <div class="col-md-6 col-xl-12 " style="display: inline-block;">
                <p class="item-title">Services We Offer</p>
                <div class="card11">
                  <div class="item-image-services-tall">
                  <img src="aiImg/index/services.jpg" alt="" style="height:100%;"/>
                     &nbsp;
                  </div>
                  <div class="item-text-container-tall">
                    AI Integration is a full life cycle software solutions company. Areas of expertise include production
                    AI integration, Cloud architecture and migration, DevOps, Software engineering, Web application
                    solutions, enterprise solution architecture, and data visualization.
                    <br>
                    AI Integration's goal is to help you succeed. You can view our capabilities here , and if you have any
                    questions, please contact us.
                    <br>
                    <br>
                    <a class="" style="float:right; height:27px;" href="#/services">
                        <p>Services</p>
                    </a>
                  </div>
                </div>
            </div>
            <div class="col-md-6 col-xl-12 " style="display: inline-block;">
                <p class="item-title">AI News</p>
                <div class="card11">
                <div class="item-image-news-tall">
                <img src="aiImg/index/news.jpg" alt="" style="height:100%;"/>
                  &nbsp;
                </div>
                <div class="item-text-container-tallnews">
                  From the White House report, " Preparing for the future of Artificial Intelligence "<br>
                  Director, Office of Science and Technology Policy, John Holdren writes:<br>
                  <br>
                  Advances in Artificial Intelligence (AI) technology have opened up new markets and new
                  opportunities for progress in critical areas such as health, education, energy, and the
                  environment. In recent years,machines have surpassed humans in the performance of certain
                  specific tasks, such as some aspects of image recognition. . . . In the coming years, AI
                  will continue to contribute to economic growth and will be a valuable tool for improving the world . . .
                  <br>
                  <br>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from '@/components';

export default {
  components: {
    Card,
    Tabs,
    TabPane
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}

img {
    position:relative;
    object-fit: cover;
}

.itemHeader {
      background-color: #eeeeee;
      color: #2c2c2c;
      margin-top: 0;
   }
</style>
